module.exports = __webpack_public_path__ + "static/media/38-9.8a79f1e1.mp3";